export class RegExHelper {
    static username = /^saijon$/i;
    static email = /^([a-zA-Z0-9._%-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/; ////^(([^<>()\[\]\\.,;:\s@"]+(\.[^ <>() \[\]\\.,;: \s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static length10 = /^[A-Za-z\d$@$!%*?&]{10,}/;
    static tinLength = /^\b\d{9}?\b$/;
    static orgTinLength = /^\b\d{5}?\b$/;
    static npiLength = /^\b\d{10}?\b$/;
    static phoneLength = /^\b\d{10}?\b$/;
    static length5 = /^\b\d{5}(-\d{4})?\b$/;
    static oneUpperCase = /^(?=.*[A-Z])/;
    static oneLowerCase = /^(?=.*[a-z])/;
    static oneNumber = /^(?=.*\d)/;
    static oneSpecialChar = /^(?=.*[$@$!%*?&])/;
    static numbersOnly = /^[0-9]+$/;
    static textOnly = /^[a-zA-Z]+$/;
    static titleOnly = /^[a-zA-Z .,'-]+$/;
    static alphaNumeric = /^[a-zA-Z0-9 ]+$/;
    static decimalsOnly = /^(100|([0-9][0-9]?(\.\d?\d?\d?\d?)?))$/;
    static dateOnly = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(19|20)\d{2}$/;
}